export const providerNameValidation = (order) =>
  order?.providerGroup?.providerGroupName || order?.providerName || '';
